import {
  AiContentGenerator01Icon,
  BookOpen01Icon,
  TestTube01Icon,
  WorkflowSquare05Icon,
} from "@hugeicons/core-free-icons"

export const CONFIG = {
  prompt: { label: "Prompts", name: "prompt", icon: AiContentGenerator01Icon },
  workflow: {
    label: "Workflows",
    name: "workflow",
    icon: WorkflowSquare05Icon,
  },
  evaluation: {
    label: "Evaluations",
    name: "evaluation",
    icon: TestTube01Icon,
  },
  ["knowledge-base"]: {
    label: "Knowledge Bases",
    name: "knowledge base",
    icon: BookOpen01Icon,
  },
}
